import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAdminAccounts, getFreeNewsletterAccounts} from 'src/openapi/admin/apis/GetSystemAccountsApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    selectAdminAccountIds,
    selectFreeNewsletterAccountIds,
} from './system-accounts.slice';

export const useSystemAccounts = () => {
    const apiDispatch = useAppDispatch();

    const adminAccountIds = useSelector(selectAdminAccountIds);
    const freeNewsletterAccountIds = useSelector(selectFreeNewsletterAccountIds);

    const loadSystemAccounts = useCallback(async () => {
        await apiDispatch(getAdminAccounts());
        await apiDispatch(getFreeNewsletterAccounts());
    }, [apiDispatch]);

    const isAdminAccount = useCallback((accountId: number) => (
        adminAccountIds.includes(accountId)
    ), [adminAccountIds]);

    const isFreeNewsletterAccount = useCallback((accountId: number) => (
        freeNewsletterAccountIds.includes(accountId)
    ), [freeNewsletterAccountIds]);

    return {
        loadSystemAccounts,
        adminAccountIds,
        freeNewsletterAccountIds,
        isAdminAccount,
        isFreeNewsletterAccount,
    };
};
